import Quill from "quill";
import Constants from "../Constants";
import Helpers from "../Helpers";

let Embed = Quill.import("blots/embed");

class AttachmentBlot extends Embed {
    static create(value) {
        let id, name, href;

        const arr = `${value}`.split(Constants.ID_SPLIT_FLAG);
        if (arr.length > 1) {
            id = arr[0];
            name = arr[1];
            href = arr[2];
        }

        let node = document.createElement("div");
        node.classList.add(AttachmentBlot.className)
        // if (id) {
            node.innerHTML = Helpers.attachmentHTML(name);
            node.setAttribute("id", id);
            node.setAttribute("data-name", name);
            node.classList.add("attachment-preview-box");
            if (href) {
                node.setAttribute("data-url", href);
                const loader = node.getElementsByClassName("attachment-loader")[0];
                loader.style.display = "none";
                const a = node.getElementsByClassName("attachment-name")[0];
                a.setAttribute("href", href);
                const img = new Image();
                img.onload = () => {
                    node.getElementsByClassName("attachment-preview")[0].setAttribute("src", href);
                }
                img.src = href;
            }

            const clearButton = node.getElementsByTagName("button")[0];
            clearButton.addEventListener("click", () => {
                node.remove();
            });
        // }
        return node;
    }

    static value(node) {
        const id = node.getAttribute("id");
        const name = node.getAttribute("data-name");
        const url = node.getAttribute("data-url");
        return [id, name, url].join(Constants.ID_SPLIT_FLAG);
    }
}

AttachmentBlot.tagName = "div";
AttachmentBlot.blotName = Constants.blots.attachment;
AttachmentBlot.className = Constants.QUILL_UPLOAD_HOLDER_CLASS_NAME;

export default AttachmentBlot;
